import React, { FC, forwardRef } from 'react';
import { ButtonBase, ButtonBaseProps } from '@mui/material';
import { ArrowCircleDownIcon } from '@/src/components/icon/stroke/ArrowCircleDownIcon';
import { ArrowCircleDownFilledIcon } from '@/src/components/icon/filled/ArrowCircleDownFilledIcon';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

/**
 * TableSortLabel.IconComponent that is replaced with IconButton
 */
export const TableSortLabelIcon: FC<ButtonBaseProps> = forwardRef(({ sx, ...rest }, ref) => {
  return (
    <ButtonBase
      sx={(theme) => ({
        ...getFocusRingStyle(theme),
        borderRadius: '100%',
        ...sx,
      })}
      ref={ref}
      aria-label="Change Sorting"
      {...rest}
    >
      <ArrowCircleDownIcon className="FlowTableSortLabel-icon" fontSize="extraSmall" />
      <ArrowCircleDownFilledIcon
        className="FlowTableSortLabel-filledIcon"
        fontSize="extraSmall"
        sx={{
          // hidden by default, appears with hover and active (tableSortLabel.theme)
          position: 'absolute',
          opacity: '0',
        }}
      />
    </ButtonBase>
  );
});
